'use strict';

// Require optional shared components
require(['componentLoader'], function (helper) {
  var config = THEHUT.config;

  helper.requireDependencies();
});

define(['siteObj'], function (siteObj) {

  var MyVitamins = function MyVitamins() {

    var self = this;

    function initAccountCreationScript() {
      // account creation page script
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    }

    function initGandalfScript() {
      // Gandalf
      if (siteObj.features.projectGandalf.active === true) {

        if (siteObj.sectionName === 'contact-us' || siteObj.page === 'contact-us') {
          require(['mvtBSContactP1']);
        }

        if (siteObj.page === 'customer-service') {
          require(['mvtBSContactP2']);
        }
      }

      if (siteObj.sectionName === 'customer-service') {
        require(['faq']);
      }
    }

    function init() {

      self.initAccountCreationScript();

      self.initGandalfScript();

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }

    self.init = init;
    self.initAccountCreationScript = initAccountCreationScript;
    self.initGandalfScript = initGandalfScript;
  };

  var myvits = new MyVitamins();
  myvits.init();
  return myvits;
});
//# sourceMappingURL=myvitamins.js.map
